'use client';
import React, { useEffect, useState, useCallback } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import GloLayout from 'lowcode/common/GloLayout';
import { defaultConfig, BANNER_STATUS } from '../config';
import { LangText } from '../textLang';
import styles from './index.module.scss';
import BannerCountDown from './BannerCountDown';
import BannerEmail from './BannerEmail';
import { useGlobal } from '@/utils/useGlobal';

const Content: React.FC<any> = ({ id, data }) => {
    const { useLang, useRouter, getSystemTime, gtm } = useGlobal();
    const { locale } = useRouter();
    const langTxt = LangText[locale] || LangText['us'];
    const {
        titleColor,
        title = defaultConfig.defaultTitle,
        subtitle = defaultConfig.defaultSubtitle,
        subtitleColor,
        activeLabel = defaultConfig.defaultLabel,
        labelColor,
        activeTimeLine,
        activityType = defaultConfig.activityType,
        align = defaultConfig.align,
        subscription,
        countdown,
        countdownBgColor,
        countdownNumColor,
        countdownTextColor,
        image,
        mobileImage,
        activeComponent_before,
        learnMoreLink_before,
        learnMoreLinkColor_before,
        linkCustomizeColor_before,
        learnMoreBtnColor_before,
        learnMoreCustomizeBtnColor_before,
        activeComponent_active,
        learnMoreLink_active,
        learnMoreLinkColor_active,
        linkCustomizeColor_active,
        learnMoreBtnColor_active,
        learnMoreCustomizeBtnColor_active,
        emarsysFields,
        isDefaultChecked,
        titleCustomizeColor,
        subtitleCustomizeColor,
        signUpBtnColor,
        learnMoreText_before = langTxt.learn_btn,
        learnMoreText_active = langTxt.learn_btn,
    } = data;
    const [status, setStatus] = useState<string>(BANNER_STATUS.end);

    const getBannerStatus = useCallback(() => {
        if (!activeTimeLine) {
            setStatus(BANNER_STATUS.teaser);
            return;
        }
        const systemTime = getSystemTime();
        if (new Date(`${activeTimeLine[0].replaceAll('-', '/')} GMT+8`).getTime() > systemTime) {
            setStatus(BANNER_STATUS.teaser);
            return;
        }
        if (
            new Date(`${activeTimeLine[0].replaceAll('-', '/')} GMT+8`).getTime() <= systemTime &&
            systemTime <= new Date(`${activeTimeLine[1].replaceAll('-', '/')} GMT+8`).getTime()
        ) {
            setStatus(BANNER_STATUS.activity);
        } else {
            setStatus(BANNER_STATUS.end);
        }
    }, [getSystemTime, activeTimeLine]);

    const getLinkColor = () => {
        if (status === BANNER_STATUS.teaser) {
            return learnMoreLinkColor_before === '3'
                ? linkCustomizeColor_before
                : learnMoreLinkColor_before
                ? learnMoreLinkColor_before
                : defaultConfig.learnMoreLinkColor_before;
        }
        if (status === BANNER_STATUS.activity) {
            return learnMoreLinkColor_active === '3'
                ? linkCustomizeColor_active
                : learnMoreLinkColor_active
                ? learnMoreLinkColor_active
                : defaultConfig.learnMoreLinkColor_active;
        }
        return '';
    };

    const getBtnColor = () => {
        if (status === BANNER_STATUS.teaser) {
            return learnMoreBtnColor_before === '3'
                ? learnMoreCustomizeBtnColor_before
                : learnMoreBtnColor_before
                ? learnMoreBtnColor_before
                : defaultConfig.learnMoreBtnColor_before;
        }
        if (status === BANNER_STATUS.activity) {
            return learnMoreBtnColor_active === '3'
                ? learnMoreCustomizeBtnColor_active
                : learnMoreBtnColor_active
                ? learnMoreBtnColor_active
                : defaultConfig.learnMoreBtnColor_active;
        }
        return '';
    };

    const handleLearnMore = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'jump_button',
            button_name: LangText[locale].learn_btn,
            position: 'Inpage',
            url: status === BANNER_STATUS.teaser ? learnMoreLink_before : learnMoreLink_active,
        });
    };

    const styleComp: any = {
        '--member-banner-titleColor': titleColor === '3' ? titleCustomizeColor : titleColor || defaultConfig.titleColor,
        '--member-banner-subTitleColor': subtitleColor === '3' ? subtitleCustomizeColor : subtitleColor || defaultConfig.subtitleColor,
        '--member-banner-labelColor': labelColor || defaultConfig.labelColor,
        '--member-banner-countdownBgColor': countdownBgColor || defaultConfig.countdownBgColor,
        '--member-banner-countdownNumColor': countdownNumColor || defaultConfig.countdownNumColor,
        '--member-banner-countdownTextColor': countdownTextColor || defaultConfig.countdownTextColor,
        '--member-banner-learnMoreLinkColor': getLinkColor(),
        '--member-banner-learnMoreBtnColor': getBtnColor(),
        '--member-banner-signUpBtnColor': signUpBtnColor || defaultConfig.signUpBtnColor,
    };

    const createEmailText = () => {
        if (status === BANNER_STATUS.teaser) {
            if (activeComponent_before === '1') {
                return <BannerEmail data={data} />;
            } else if (activeComponent_before === '2') {
                return (
                    <BannerCountDown data={data} handleEnd={() => console.log('timeend')} activityDateArr={activeTimeLine} status={status}></BannerCountDown>
                );
            } else if (activeComponent_before === '3') {
                return (
                    <a className="learn-btn" href={learnMoreLink_before ? learnMoreLink_before : null} target="_blank" rel="noopener noreferrer">
                        <button onClick={handleLearnMore}>{learnMoreText_before}</button>
                    </a>
                );
            }
            return <></>;
        } else if (status === BANNER_STATUS.activity) {
            if (activeComponent_active === '1') {
                return <BannerEmail data={data} />;
            } else if (activeComponent_active === '2') {
                return (
                    <BannerCountDown data={data} handleEnd={() => console.log('timeend')} activityDateArr={activeTimeLine} status={status}></BannerCountDown>
                );
            } else if (activeComponent_active === '3') {
                return (
                    <a className="learn-btn" href={learnMoreLink_active ? learnMoreLink_active : null} target="_blank" rel="noopener noreferrer">
                        <button onClick={handleLearnMore}>{learnMoreText_active}</button>
                    </a>
                );
            }
            return <></>;
        }
        return <></>;
    };

    useEffect(() => {
        getBannerStatus();
    }, [activeTimeLine, getBannerStatus]);

    return (
        <GloLayout id={id} className={`${status === BANNER_STATUS.end ? 'temp-hide' : styles.appreciation_day_banner}`}>
            <div className="top_tips"></div>
            <div
                className={`banner ${align} ${activityType} GtmModuleData-section`}
                data-section-id={'Member-Banner'}
                data-section-title={title || 'Member-Banner'}
            >
                <EditorImg
                    pc={image ? image : activityType === 'active' ? defaultConfig.image : defaultConfig.referralImg}
                    h5={mobileImage ? mobileImage : activityType === 'active' ? defaultConfig.mobileImage : defaultConfig.referralMobileImage}
                    className="banner-kv"
                />
                <div className="text_box" style={styleComp}>
                    <div className="subtitle">{activeLabel}</div>
                    <div className="title">{title}</div>
                    <div className="desc">{subtitle}</div>
                    {createEmailText()}
                </div>
            </div>
        </GloLayout>
    );
};

export default Content;
